import { FileTextIcon, DownloadIcon, BotIcon, CopyIcon, BriefcaseIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: DownloadIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Compatible with ChatGPT, Claude, Gemini & other AI assistants'
}, {
  icon: CopyIcon,
  label: 'Copy-and-Customize Prompt Frameworks'
}, {
  icon: BriefcaseIcon,
  label: 'Designed for Practical Freelance Workflows'
}];
export const heroPillars = 'Client Briefs · Project Scope · Deliverables · Proposal Writing · Value Presentation · Quality Control';
export const stats = [{
  value: "300+",
  label: "Freelancers satisfied"
}, {
  value: "6 + 5",
  label: "Volumes + Bonus"
}, {
  value: "99%",
  label: "Success Rate"
}, {
  value: "4.9/5",
  label: "Global Rating"
}];